import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core'
import {
  ListNavigationModule,
  ProductListModule,
  StarRatingModule,
  IconModule,
  MediaModule,
  SpinnerModule,
} from '@spartacus/storefront'
import { RouterModule } from '@angular/router'
import { ProductFacetNavigationModule } from './product-facet-navigation/product-facet-navigation.module'
import { ListItemComponent } from './product-list-item/product-list-item.component'
import { GridItemComponent } from './product-grid-item/product-grid-item.component'
import { ListComponent } from './list/list.component'
import { MatDialogModule } from '@angular/material/dialog'
import { FormsModule } from '@angular/forms'
import { ProductNotFoundComponent } from './product-not-found/product-not-found.component'
import { PlpBannerComponent } from './plp-banner/plp-banner.component'
import { PlpHomepageComponent } from './plp-homepage/plp-homepage.component'
import { AddToCartModule } from '../cart/add-to-cart/add-to-cart.module'
import { ProductViewComponent } from './product-view/product-view.component'
import { PlpCategoryBannerComponent } from './plp-category-banner/plp-category-banner.component'
import { MatTooltipModule } from '@angular/material/tooltip'
import { PlpService } from './plp.service'
import { NgSelectModule } from '@ng-select/ng-select'
import { ClickOutsideModule } from '../../shared/directive/clickOutside/click-outside.module'
import { environment } from '../../../environments/environment'

@NgModule({
  declarations: [
    ListComponent,
    ListItemComponent,
    GridItemComponent,
    ProductNotFoundComponent,
    PlpBannerComponent,
    PlpHomepageComponent,
    ProductViewComponent,
    PlpCategoryBannerComponent,
  ],
  imports: [
    CommonModule,
    ListNavigationModule,
    I18nModule,
    UrlModule,
    StarRatingModule,
    IconModule,
    RouterModule,
    ProductListModule,
    MediaModule,
    ProductFacetNavigationModule,
    MatDialogModule,
    AddToCartModule,
    FormsModule,
    ProductFacetNavigationModule,
    ClickOutsideModule,
    MatTooltipModule,
    SpinnerModule,
    // NavBarModule,
    NgSelectModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['plp'],
        },
      },
      cmsComponents: {
        CMSProductListComponent: {
          component: ListComponent,
        },
        ProductGridComponent: {
          component: ListComponent,
        },
        SearchResultsListComponent: {
          component: ListComponent,
        },
        VSCategoryDisplayComponent: {
          component: PlpCategoryBannerComponent,
        },
      },
    } as CmsConfig),
  ],
  exports: [PlpBannerComponent, PlpHomepageComponent],
  providers: [PlpService],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class PlpModule {}
